<div class="lp-app-layout">
  <router-outlet />
  <dm-toaster position="bottom-right" />
  <lp-confirm-dialog />
</div>
